<template>
  <section id="team" class="team">
    <div class="header-box">
        <h2>Unser Team</h2>
    </div>
    <b-container col="*">
      <b-row>
        <b-col>
          <b-card
              title="10 Mitarbeiter"
              img-src="../../assets/images/mitarbeiter.svg"
              img-alt="Mitarbeiter"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Schulungen"
              img-src="../../assets/images/schulungen.svg"
              img-alt="Schulungen"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Teamwork"
              img-src="../../assets/images/teamwork.svg"
              img-alt="Teamwork"
              img-top>
          </b-card>
        </b-col>
        <b-col>
          <b-card
              title="Experten"
              img-src="../../assets/images/experts.svg"
              img-alt="Experten"
              img-top>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <div class="team-about">
      <div class="text">
        Die Gartenfee besteht zur Zeit aus 7 Mitarbeitern und 3 Aushilfen.
        Das Personal wird regelmäßig geschult, sodass es kompetent alle Aufgaben meistern kann. Teamwork wird bei uns großgeschrieben. Durch unsere unterschiedlichen Interessen und Erfahrungen ergänzen wir uns ideal.
        Dabei setzen alle auf ihre individuellen Schwerpunkte ohne die Zusammenarbeit im Team aus den Augen zu verlieren. Gegenseitige Unterstützung ist für uns selbstverständlich, so dass unsere Kunden vom geballten Team-Wissen profitieren. So können wir die unterschiedlichsten Anfragen und Anliegen stets zuverlässig und kompetent bearbeiten.
      </div>
      <div class="image">
        <b-img src="../../assets/images/team-about.jpg" />
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Team',
  }
</script>

<style lang="scss">
  @import '../../assets/styles/home/team.scss';
</style>
